import { render, staticRenderFns } from "./ShowCustomerData.vue?vue&type=template&id=7f05f781&scoped=true&lang=pug"
import script from "./ShowCustomerData.vue?vue&type=script&lang=js"
export * from "./ShowCustomerData.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomerData.vue?vue&type=style&index=0&id=7f05f781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f05f781",
  null
  
)

export default component.exports